import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import authService from '../slice/authService';
import ZoomSession from '../slice/ZoomSession';
const reducerlist = combineReducers({
    auth: authService,
    ZoomSession: ZoomSession
});
const persistConfig = {
    key: 'root',
    storage,
}
const persistedReducer = persistReducer(persistConfig, reducerlist)
export const store = configureStore({
    reducer: persistedReducer,
    devTools: true,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false,
    }),
})
export const persistor = persistStore(store)
export default store;    
